export default __webpack_public_path__ + "static/media/send-to-phone.0da3a5f4.svg";